import styled from "styled-components";
import { Icon } from "_/components/icon";

export const FileDownloadLink = styled.a<{ $variant?: "muted" | "plain" }>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: ${(p) =>
    p.$variant === "plain" ? p.theme.text.default : p.theme.text.muted};
  white-space: nowrap;

  &:hover {
    color: ${(p) => p.$variant === "muted" && p.theme.text.hover};
    text-decoration: ${(p) => (p.$variant === "plain" ? "none" : "underline")};
  }

  &.disabled-link {
    pointer-events: none;
    color: gray;
    text-decoration: none;
    cursor: default;
  }

  ${Icon} {
    font-size: 1.25rem;
  }
`;
